import { Component, OnInit, NgZone } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Menu, Category, Item, ServiceItem, Extra } from 'src/app/models/menu.model';
import { Order, OrderGroup } from 'src/app/models/order.model';
import { ModalController } from '@ionic/angular';
import { UtilService } from 'src/app/services/util.service';
import { ExtraService } from 'src/app/services/extra.service';
import { OrderService } from 'src/app/services/order.service';
import { WifiService } from 'src/app/services/wifi.service';
import { EditItemComponent } from 'src/app/components/edit-item/edit-item.component';
import { CATEGORY, SERVICE, ITEM, ANALYTICS_EV_ADD_TO_BASKET } from 'src/environments/constant';
import { ViewChild } from '@angular/core';
import { Input } from '@angular/core';
import { Events } from 'src/app/services/events.service';

import { DBService } from 'src/app/services/db.service';
import { Router } from '@angular/router';
import { OptionService } from 'src/app/services/option.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.page.html',
  styleUrls: ['./menu.page.scss'],
})
export class MenuPage implements OnInit {

  public selectedCategory: Category;
  public selectedCategory2: Category;
  public selectedItem: Item;

  @ViewChild('shoppingcardbt', { static: false }) private shoppingCardBt: any;
  @Input() openID: number;

  //private amount: number = 1;
  searchControl: FormControl;

  constructor(public router: Router, public db: DBService, public util: UtilService, private events: Events, private modalController: ModalController,
    private wifiService: WifiService, private orderService: OrderService, private ngZone: NgZone, private extraService: ExtraService, private optionService: OptionService) {

    this.events.unsubscribe('backButtonInMenu')
    this.events.subscribe('backButtonInMenu', () => {
      this.util.warn("EVENT ausgelöst: backButtonInMenu")
      this.back()
    });
  }

  ngOnInit() {
    if (!this.db.currentRestaurantKey) {
      this.ngZone.run(() => this.router.navigate(['/restaurant-list']))
      return
    }

    this.db.currentPage = 'menu'

    this.selectedItem = undefined
    this.selectedCategory = undefined
    this.selectedCategory2 = undefined

    let val:any = localStorage.getItem('openID')
    if (val) {
      val = JSON.parse(val)
      if (this.db.shadowCopyCategories[val]) {
        let category: Category = this.db.shadowCopyCategories[val]
        if (category.parentCatID === -1) {
          this.selectedCategory = category
        } else {
          this.selectedCategory = this.db.findParentCategory(category)
          this.selectedCategory2 = category
        }
      } else if (this.db.shadowCopyItems[val]) {
        let item: Item = this.db.shadowCopyItems[val]
        if (item.rootCatID === item.parentCatID) {
          this.selectedCategory = this.db.findCategory(val)
        } else {
          this.selectedCategory2 = this.db.findCategory(val)
          this.selectedCategory = this.db.findParentCategory(this.selectedCategory2)
        }
        this.addToBasketPopup(item)
      } else if (this.db.findArticleByID(val)) {
        let category: any = this.db.findArticleByID(val)
        if (category.parentCatID === -1) {
          this.selectedCategory = category
        } else {
          this.selectedCategory = this.db.findParentCategory(category)
          this.selectedCategory2 = category
        }
      }
    }

    localStorage.removeItem('openID');

    this.orderService.initRouter(this.router)
    // this.wifiService.networks = []
    // this.wifiService.initStartWifiScreening();
  }

  ionViewWillLeave() {
    this.util.popover.dismiss();
    this.modalController.dismiss();
  }

  addAnimationAfterAddedToBasket() {
    if (this.shoppingCardBt && this.shoppingCardBt.el && this.shoppingCardBt.el.classList) {
      let myRef = this
      this.shoppingCardBt.el.classList.add('addToBasket');
      setTimeout(() => {
        if (myRef.shoppingCardBt && myRef.shoppingCardBt.el && myRef.shoppingCardBt.el.classList)
          myRef.shoppingCardBt.el.classList.remove('addToBasket');
      }, 3000);
    }
  }

  ngAfterViewInit() {
    //this.db.setPage('menu')
  }

  back() {
    this.util.info("BACKT_BT_IN_MENÜ: selectedItem, selectedCategory, selectedCategory2", this.selectedItem, this.selectedCategory, this.selectedCategory2)

    //Suche Methode
    if (this.searchTerm && this.searchTerm.length > 0) {
      this.selectedItem = null
      this.selectedCategory = null
      this.selectedCategory2 = null
      this.searchTerm = ""

      return
    }


    //Wenn gar nicht ausgeloest ist, dann raus
    if (!this.selectedItem && !this.selectedCategory && !this.selectedCategory2) {
      this.util.info("BACKT_BT_IN_MENÜ: Zurück zur Startseite")
      this.db.setPage('home')
      if (!this.db.loggedUserUID || !(this.db.isOwner || this.db.isEmployee)) this.ngZone.run(() => this.router.navigate(['/customer-home']))
      else this.ngZone.run(() => this.router.navigate(['/owner-home']))

      return
    }

    //Wenn Item offen ist, dann zu machen
    if (this.selectedItem) {
      this.util.info("BACKT_BT_IN_MENÜ: Item schliessen / Bei der Seite bleiben")
      this.ngZone.run(() => this.selectedItem = undefined)
      // this.db.setPage('menu')
      return
    }

    if (this.selectedCategory2) {
      this.util.info("BACKT_BT_IN_MENÜ: Unterkategorie schliessen / Bei der Seite bleiben")
      this.ngZone.run(() => this.selectedCategory2 = undefined)
    }
    else if (this.selectedCategory) {
      this.util.info("BACKT_BT_IN_MENÜ: Kategorie schliessen / Bei der Seite bleiben")
      this.ngZone.run(() => this.selectedCategory = undefined)
    }

    this.util.info("BACKT_BT_IN_MENÜ_ENDE: selectedItem, selectedCategory, selectedCategory2", this.selectedItem, this.selectedCategory, this.selectedCategory2)
    // this.db.setPage('menu')
  }

  removePrice(item: Item) {
    item.price = null
  }

  addToBasketPopup(item: Item) {
    //this.selectItem(item)
    this.util.popup('', [this.db.findCategory(item.id).name, item], 'addToBasket', -1)
    this.events.unsubscribe('addToBasketPopoverDismissed-' + this.util.timeWhenAs2AddBasket)
    this.util.timeWhenAs2AddBasket = new Date().getTime(); //((Braucht man, damit nur das letzte gilt))

    //Callback of Popover
    this.events.subscribe('addToBasketPopoverDismissed-' + this.util.timeWhenAs2AddBasket, (res) => {
      if (res && res.data) {
        this.addToBasket(item, res.data.amount, res.data.extraSinglePrice, res.data.extraNames, res.data.selectedOption, res.data.selectedOptionSinglePrice, res.data.note);
        this.events.unsubscribe('addToBasketPopoverDismissed-' + this.util.timeWhenAs2AddBasket)
      }
    });
  }

  addToBasket(item: Item, amount: number, extraSinglePrice: number, extraNames: string, selectedOption: string, selectedOptionSinglePrice:number, note: string = '') {
    if (!amount || amount <= 0) return

    let order: Order = new Order('')
    order.amount = amount
    order.note = note
    order.itemKey = item.id
    order.optionString = selectedOption
    order.optionPrice = selectedOptionSinglePrice
    order.extraPrice = extraSinglePrice
    order.extraString = extraNames
    
    this.db.addAnalytics(ANALYTICS_EV_ADD_TO_BASKET, {item: item.name, itemId: order.itemKey, amount: order.amount, note: order.note})    
    
    this.db.addToBasket(order);
    this.addAnimationAfterAddedToBasket();

    // this.db.setPage('menu')

    //takeawayprice is not shown here, since it is not clear, if it is for take-away or... . only shown in basket view. put req. in descr. to let your users know
    let price: number = this.db.findItem(order.itemKey).isSpecialPriceActive ? this.db.findItem(order.itemKey).specialPrice : this.db.findItem(order.itemKey).price;
    let text = amount + ' x ' + this.db.findCategory(order.itemKey).name + ' ' + this.db.findItem(order.itemKey).name + ' á ' + this.util.formatPrice(price) + ' €'
    if (extraSinglePrice && extraSinglePrice > 0) {
      text += '(+ je ' + this.util.formatPrice(extraSinglePrice + selectedOptionSinglePrice) + ' € für Extras)'
    }
    this.util.popup('green', text, 'addedToBasket');
  }

  backToCategoryOverview() {
    this.ngZone.run(() => {
      this.selectedCategory = null
      this.selectedCategory2 = null
      this.selectedItem = null
    })
  }







  /**********************
   *  GET FUNCT
   **********************/
  getServices() {
    if (this.db.currentMenu && this.db.currentMenu.service) {
      return this.db.currentMenu.service.sort((n1, n2) => {
        if (n1.position > n2.position)
          return 1;
        else
          return -1;
      });
    } else {
      return []
    }
  }

  getCategories() {
    if (this.db.currentMenu && this.db.currentMenu.category) {
      return this.db.currentMenu.category.sort((n1, n2) => {
        if (n1.position > n2.position)
          return 1;
        else
          return -1;
      });
    } else {
      return []
    }
  }

  getSubCategories(parentCat: Category) {
    if (parentCat.categories) {
      return parentCat.categories.sort((n1, n2) => {
        if (n1.position > n2.position)
          return 1;
        else
          return -1;
      });
    } else {
      return []
    }
  }

  getItems(parentCat: Category) {
    if (parentCat.items) {
      return parentCat.items.sort((n1, n2) => {
        if (n1.position > n2.position)
          return 1;
        else
          return -1;
      });
    } else {
      return []
    }
  }



  /**********************
   *  CREATE FUNCT
   **********************/
  async openCreatePageCategory(menu: Menu, createNew: boolean = true, cat?: Category) {
    if (menu && menu.category) {
      if (createNew) cat = new Category("", menu.category.length)
      else {
        this.extraService.storeExtrasOrgState(cat);
        this.optionService.storeOptionsOrgState(cat);
      }
      const modal = await this.modalController.create({
        component: EditItemComponent,
        componentProps: { type: CATEGORY, category: cat }
      });

      await modal.present();
      await modal.onDidDismiss().then((res: any) => {
        this.util.isModalOpen = false
        if (res && res.data) {
          if (createNew) menu.category.push(res.data)
          else {
            cat = res.data
            this.extraService.updateExtraItems(cat)
            this.optionService.updateOptionItems(cat)
          }
          this.updatePosition(this.db.currentMenu.category)
          this.save()
        }
      })
    }
  }

  async openCreatePageSubCategory(parentCat: Category, createNew: boolean = true, cat?: Category) {
    if (!parentCat) return
    if (!parentCat.categories) {
      parentCat.categories = []
    }

    if (createNew) cat = new Category("", parentCat.categories.length, parentCat.id)
    else {
      parentCat = this.db.findParentCategory(cat);
      this.extraService.storeExtrasOrgState(cat);
      this.optionService.storeOptionsOrgState(cat);
    }
    const modal = await this.modalController.create({
      component: EditItemComponent,
      componentProps: { type: CATEGORY, category: cat }
    });

    await modal.present();
    await modal.onDidDismiss().then((res: any) => {
      this.util.isModalOpen = false
      if (res && res.data) {
        this.updateCategories()
        parentCat = this.db.findCategoryByCat(parentCat);
        if (createNew) parentCat.categories.push(res.data)
        else {
          cat = res.data
          this.extraService.updateExtraItems(cat)
          this.optionService.updateOptionItems(cat)
        }
        this.updatePosition(parentCat.categories)
        this.save()
      }
    })
  }

  async openCreatePageService(menu: Menu, createNew: boolean = true, service?: ServiceItem) {
    if (menu && menu.category) {
      if (createNew) service = new ServiceItem("", menu.service.length)
      const modal = await this.modalController.create({
        component: EditItemComponent,
        componentProps: { type: SERVICE, service: service }
      });

      await modal.present();
      await modal.onDidDismiss().then((res: any) => {
        this.util.isModalOpen = false
        if (res && res.data) {
          if (createNew) menu.service.push(res.data)
          else service = res.data
          this.updatePosition(this.db.currentMenu.service)
          this.save()
        }
      })
    }
  }

  async openCreatePageItem(category: Category, createNew: boolean = true, item?: Item) {
    if (!category) return
    if (!category.items) {
      category.items = []
    }

    let parentID: number = category.id, rootID: number
    if (category.parentCatID) {
      rootID = category.parentCatID
    }

    if (createNew) item = new Item("", 1.00, category.items.length, parentID, rootID);
    const modal = await this.modalController.create({
      component: EditItemComponent,
      componentProps: { type: ITEM, item: item }
    });

    await modal.present();
    await modal.onDidDismiss().then((res: any) => {
      this.util.isModalOpen = false
      if (res && res.data) {
        this.updateCategories();
        if (createNew) {
          this.db.findCategoryByCat(category).items.push(res.data) //TODO: ACHTUNG, ER ERKENNT CATEGPRY NICHT ALS TEIL VON MENU!!!!
          this.extraService.updateExtraItems(category)
          this.optionService.updateOptionItems(category)
        }
        else {
          item = res.data
          // item = this.db.findItem(item.id)
          this.db.updateItem(item)
        }

        try{
          this.extraService.norm(item.extras)
          this.optionService.norm(item.options)
        } catch (e) {
          this.util.log('Error norming extras & options', e)
        }

        this.updatePosition(category.items)
        this.save()
      }
    })

  }








  /**********************
   *  Sort / Order by Alphabet
   **********************/
  orderItemsByAlhpabet() {
    //*** Items in Cat ***/
    for (let cat of this.db.currentMenu.category) {
      if (cat.items) {
        cat.items = cat.items.sort((n1, n2) => {
          if (n1.name.toLowerCase() > n2.name.toLowerCase()) return 1;
          if (n1.name.toLowerCase() < n2.name.toLowerCase()) return -1;
          return 0;
        });

        //Position aktualisieren
        cat.items.forEach((item, index) => {
          cat.items[index].position = index
        });
      }

      //*** Items in Subcategory ***/
      if (cat.categories) {
        for (let subCat of cat.categories) {
          subCat.items = subCat.items.sort((n1, n2) => {
            if (n1.name.toLowerCase() > n2.name.toLowerCase()) return 1;
            if (n1.name.toLowerCase() < n2.name.toLowerCase()) return -1;
            return 0;
          });

          //Position aktualisieren
          subCat.items.forEach((item, index) => {
            subCat.items[index].position = index
          });
        }
      }
    }
    this.save()
  }

  /**********************
   *  REORDER FUNCT
   **********************/
  reorderServices(ev: any) {
    this.util.log(ev, ev.detail)
    if (ev && ev.detail) {
      if (ev.detail.to >= this.db.currentMenu.service.length) {
        ev.detail.to = this.db.currentMenu.service.length - 1
      }

      this.db.currentMenu.service[ev.detail.from].position = ev.detail.to

      if (ev.detail.to < ev.detail.from) {
        for (let i = (ev.detail.to); i < ev.detail.from; i++) {
          this.db.currentMenu.service[i].position += 1;
        }
      } else {
        for (let i = (ev.detail.to); i > ev.detail.from; i--) {
          this.db.currentMenu.service[i].position -= 1;
        }
      }
      ev.detail.complete();
      this.save()
    }
  }

  reorderCategories(ev: any) {
    this.util.log(ev, ev.detail)
    if (ev && ev.detail) {
      //this.db.currentMenu.category = reorderArray(this.db.currentMenu.category, ev.detail.from, ev.detail.to);
      if (ev.detail.to >= this.db.currentMenu.category.length) {
        ev.detail.to = this.db.currentMenu.category.length - 1
      }

      this.db.currentMenu.category[ev.detail.from].position = ev.detail.to

      if (ev.detail.to < ev.detail.from) {
        for (let i = (ev.detail.to); i < ev.detail.from; i++) {
          this.db.currentMenu.category[i].position += 1;
        }
      } else {
        for (let i = (ev.detail.to); i > ev.detail.from; i--) {
          this.db.currentMenu.category[i].position -= 1;
        }
      }
      ev.detail.complete();
      this.save()
    }
  }

  reorderSubCategories(ev: any, parentCat: Category) {
    this.util.log(ev, ev.detail)
    parentCat = this.db.findCategoryByCat(parentCat)
    this.updateCategories()

    if (!parentCat) return
    //TODO Fehler beim sortieren
    if (ev && ev.detail) {
      if (ev.detail.to >= parentCat.categories.length) {
        ev.detail.to = parentCat.categories.length - 1
      }

      parentCat.categories[ev.detail.from].position = ev.detail.to

      if (ev.detail.to < ev.detail.from) {
        for (let i = (ev.detail.to); i < ev.detail.from; i++) {
          parentCat.categories[i].position += 1;
        }
      } else {
        for (let i = (ev.detail.to); i > ev.detail.from; i--) {
          parentCat.categories[i].position -= 1;
        }
      }
      ev.detail.complete();
      this.updatePosition(parentCat.categories)
      this.save()
    }
  }

  reorderItems(ev: any, parentCat: Category) {
    this.util.log("uuu", ev, ev.detail)
    parentCat = this.db.findCategoryByCat(parentCat)
    this.updateCategories()

    if (!parentCat) return

    if (ev && ev.detail) {
      if (ev.detail.to >= parentCat.items.length) {
        ev.detail.to = parentCat.items.length - 1
      }

      parentCat.items[ev.detail.from].position = ev.detail.to
      if (ev.detail.to < ev.detail.from) {
        for (let i = (ev.detail.to); i < ev.detail.from; i++) {
          parentCat.items[i].position += 1;
        }
      } else {
        for (let i = (ev.detail.to); i > ev.detail.from; i--) {
          parentCat.items[i].position -= 1;
        }
      }
      ev.detail.complete();
      this.updatePosition(parentCat.items)
      this.save()
    }
  }

  updatePosition(items: any[]) {
    if (!items) return
    items = items.sort((n1, n2) => {
      if (n1.position > n2.position)
        return 1;
      else
        return -1;
    });

    for (let i = 0; i < items.length; i++) {
      if (items[i]) items[i].position = i; //TODO IF!!!
    }
    /// this.save() todo
  }











  /**********************
   *  REMOVE FUNCT
   **********************/
  removeCategory(menu: Menu, category: Category) {
    //TODO direkt loeschen / abfrage aber dann nicht mehr extra speichern
    if (!menu || !menu.category) return
    const index = menu.category.indexOf(category, 0);
    if (index > -1) {
      this.initPopup2DeleteEntry();
      // this.events.subscribe('sureForYorOder-' + this.util.timeWhenSureToDelete, (res) => {  //TODO stimmt das???
      this.events.subscribe('sureToDelete-' + this.util.timeWhenSureToDelete, (res) => {
        if (res && res.data === true) {
          //Hier machen, dass er loescht mit switch
          menu.category.splice(index, 1);
          this.updatePosition(menu.category)
          this.events.unsubscribe('sureToDelete-' + this.util.timeWhenSureToDelete)
          this.save()
        }
      });
    }
  }

  removeService(menu: Menu, serviceItem: ServiceItem) {
    if (!menu || !menu.service) return
    const index = menu.service.indexOf(serviceItem, 0);
    if (index > -1) {
      menu.service.splice(index, 1);
      this.updatePosition(menu.service) //TODO Abfrage??
      this.save()
    }
  }

  removeSubCategory(parentCat: Category, category: Category) {
    this.updateCategories();
    parentCat = this.db.findCategoryByCat(parentCat)
    category = this.db.findCategoryByCat(category)

    if (!parentCat || !parentCat.categories) return
    const index = parentCat.categories.indexOf(category, 0);
    if (index > -1) {
      this.initPopup2DeleteEntry();
      this.events.subscribe('sureToDelete-' + this.util.timeWhenSureToDelete, (res) => { //todo ???sureToDelete
        if (res && res.data === true) {
          //Hier machen, dass er loescht mit switch
          parentCat.categories.splice(index, 1);
          this.updatePosition(parentCat.categories)
          this.events.unsubscribe('sureToDelete-' + this.util.timeWhenSureToDelete)
          this.save()
        }
      });
    }
  }

  removeItem(category: Category, item: Item) {
    //TODO: Kategorie braucht ID
    this.updateCategories();
    category = this.db.findCategoryByCat(category)
    item = this.db.findItem(item.id)
    if (!category || !category.items) return

    const index = category.items.indexOf(item, 0);
    if (index > -1) {
      this.initPopup2DeleteEntry();
      this.events.subscribe('sureToDelete-' + this.util.timeWhenSureToDelete, (res) => {  //??? todo
        if (res && res.data === true) {
          //Hier das eigentliche loeschen
          category.items.splice(index, 1);
          this.updatePosition(category.items)
          this.events.unsubscribe('sureToDelete-' + this.util.timeWhenSureToDelete)
          this.save()
        }
      });
    }
  }










  /**********************
   *  SEARCHBAR
   **********************/
  //TODO: Setze einmal die Liste
  searchTerm: string = '';
  searchResultItems: any;
  filterItems(searchTerm) {
    this.searchResultItems = []

    // *** Categories & Sub-Categories ***
    for (let cat of this.db.currentMenu.category) {
      if (cat.isActive) this.searchResultItems.push(cat) //mit concat haengt man ein ganzes array dran
      if (cat.categories && cat.isActive) {
        for (let subCat of cat.categories) {
          if (subCat.isActive) this.searchResultItems.push(subCat)
        }
      }
    }

    // *** Items in Categories & Sub-Categories ***
    for (let cat of this.db.currentMenu.category) {
      if (cat.items && cat.isActive) {
        for (let item of cat.items) {
          if (item.isActive) this.searchResultItems.push(item)
        }
      }

      if (cat.categories && cat.isActive) {
        for (let subCat of cat.categories) {
          if (subCat.items && subCat.isActive) {
            for (let item of subCat.items) {
              if (item.isActive) this.searchResultItems.push(item)
            }
          }
        }
      }
    }

    return this.searchResultItems.filter((item) => {
      return item.name && item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
              item.info && item.info.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    });
  }

  setFilteredItems() {
    this.searchResultItems = this.filterItems(this.searchTerm);
  }

  selectSearchCategory(category: Category) {
    this.searchTerm = ''
    let parentCat: Category = this.db.findParentCategory(category)

    if (parentCat) {
      this.ngZone.run(() => {
        this.selectedCategory = parentCat
        this.selectedCategory2 = category
        this.selectedItem = null
      })
    } else {
      // this.selectedCategory = category
      this.ngZone.run(() => {
        this.selectedCategory = category
        this.selectedCategory2 = null
        this.selectedItem = null
      })
    }
  }

  selectSearchItem(item: Item) {
    this.searchTerm = ''
    this.addToBasketPopup(item);
  }










  /**********************
   *  SELECT FUNCT
   **********************/
  selectService(service: ServiceItem) {
    let serviceOrder: Order = new Order(null)
    let serviceOrderGroup: OrderGroup = new OrderGroup(null);
    serviceOrder.fixedItemName = service.name
    serviceOrder.fixedPrice = 0
    serviceOrderGroup.isService = true;
    serviceOrderGroup.order.push(serviceOrder);

    this.orderService.clickOnOrderNow(serviceOrderGroup)
  }

  //TODO update vll hier einpflegen???
  selectCategory(category: Category) {
    this.ngZone.run(() => {
      this.selectedCategory = category
      this.selectedItem = null
    })
  }

  selectSubCategory(category: Category) {
    this.ngZone.run(() => {
      this.selectedCategory2 = category
      this.selectedItem = null
    })
  }

  selectItem(item: Item) {
    this.ngZone.run(() => this.selectedItem = item)
  }

  updateCategories() {
    this.ngZone.run(() => {
      this.selectedCategory = this.db.findCategoryByCat(this.selectedCategory)
      this.selectedCategory2 = this.db.findCategoryByCat(this.selectedCategory2)
    })
  }







  initPopup2DeleteEntry() {
    this.util.popup('red', null, 'sureToDelete', -1)
    this.events.unsubscribe('sureToDelete-' + this.util.timeWhenSureToDelete)
    this.util.timeWhenSureToDelete = new Date().getTime()
  }

  openBasket() {
    this.ngZone.run(() => this.router.navigate(['/basket']))
  }


  save() {
    this.util.log("in save method", this.db.currentMenu)
    this.db.updateRestaurant(this.db.currentRestaurantKey)
    this.db.updateMenu(this.db.currentMenuKey)
    //this.util.presentToast("Angaben wurden gespeichert")
  }

}
